if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          close: document.querySelectorAll('.location-close-wrapper'),
          backdrop: document.querySelectorAll('.disclosure__list-wrapper-backdrop'),
          toggle: document.querySelectorAll(".menu-toggle")
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', (event) => this.closeSelector(event, false));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

         Array.from(this.elements.toggle ?? []).forEach((toggle) => {
           toggle.addEventListener('click', (event) => this.closeSelector(event, true));
         })
        
         Array.from(this.elements.close ?? []).forEach((close) => {
          close.addEventListener('click', this.closeSelector.bind(this, (event) => this.closeSelector(event, true)));
        })

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if(this.elements.input.name == "country_code" && window.matchMedia('(min-width: 990px)').matches){
          const header = document.querySelector(".section-header");
          if(!this.elements.panel.hasAttribute("hidden")){
            const baseHeight = 311;
            const {height} = this.elements.panel.getBoundingClientRect();
            const finalHeight = height + baseHeight;
            header.classList.add('force-black');
            
            Array.from(this.elements.backdrop).forEach(el => {
              el.style.height = finalHeight + 'px'
            });
          }
          if(header.classList.contains('visible')){
            toggleMenu()
          }
        }
      }

      closeSelector(event, force) {
        if(this.elements.input.name == "country_code" && window.matchMedia('(min-width: 990px)').matches && !force){
          return;
        }

        Array.from(this.elements.backdrop).forEach(el => {
          el.style.height = 0 + 'px'
        });
        
        const header = document.querySelector(".section-header");
        header.classList.remove('force-black');
        
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
